<template>
  <div>
    <div style="width: 200px; margin-bottom: 10px; margin-left: 15px; background-color: #eff2f7; border-radius: 4px; height: 34px;">
      <button @click="chartFormat= 'week';dataLabelsEnabled=true;renderChartConvert();rotate=false;" :disabled="chartFormat === 'week'" class="button-month-week" :style="{ backgroundColor: chartFormat === 'week' ? '#556ee6d9' : '#ffffff' }">週間</button>
      <button @click="chartFormat= 'month';dataLabelsEnabled=false;renderChartConvert();rotate=true;" :disabled="chartFormat === 'month'" class="button-month-week" :style="{ backgroundColor: chartFormat === 'month' ? '#556ee6d9' : '#ffffff' }">月間</button>
    </div>
    <div class="controller d-flex align-items-center">
      <div>
        <div class="input-group" style="width: 200px; margin-left: 15px">
          <div class="input-group-prepend pointer">
            <span v-if="chartFormat === 'week'" class="input-group-text p-1" @click="prevWeek">
              <svg style="transform: scale(0.7)" width="24" height="24" fill-rule="evenodd" clip-rule="evenodd">
                <path d="M20 .755l-14.374 11.245 14.374 11.219-.619.781-15.381-12 15.391-12 .609.755z"/>
              </svg>
            </span>
            <span v-else class="input-group-text p-1" @click="prevMonth">
              <svg style="transform: scale(0.7)" width="24" height="24" fill-rule="evenodd" clip-rule="evenodd">
                <path d="M20 .755l-14.374 11.245 14.374 11.219-.619.781-15.381-12 15.391-12 .609.755z"/>
              </svg>
            </span>
          </div>
          <input type="text" class="form-control text-center py-1" readonly :value="chartFormat === 'week' ? displayRange : displayRangeMonth">
          <div class="input-group-append pointer" :class="{disabled: isFuture()}">
            <span v-if="chartFormat === 'week'" class="input-group-text p-1" @click="nextWeek">
              <svg style="transform: scale(0.7)" width="24" height="24" fill-rule="evenodd" clip-rule="evenodd">
                <path d="M4 .755l14.374 11.245-14.374 11.219.619.781 15.381-12-15.391-12-.609.755z"/>
              </svg>
            </span>
            <span v-else class="input-group-text p-1" @click="nextMonth">
              <svg style="transform: scale(0.7)" width="24" height="24" fill-rule="evenodd" clip-rule="evenodd">
                <path d="M4 .755l14.374 11.245-14.374 11.219.619.781 15.381-12-15.391-12-.609.755z"/>
              </svg>
            </span>
          </div>
        </div>
      </div>
      <div class="ms-3">
        <div class="d-inline-block standard-met">
          目標 <span class="text-danger font-weight-semibold fs-5">{{ this.standardMet }}</span>Mets
        </div>
      </div>
      <div class="ms-3">
        <div class="d-flex align-items-center">
          <span class="square" :style="{'background-color': this.barColor(100)}"></span>
          <span class="ms-1">目標達成(100%〜)</span>
        </div>
      </div>
      <div class="ms-3">
        <div class="d-flex align-items-center">
          <span class="square" :style="{'background-color': this.barColor(50)}"></span>
          <span class="ms-1">目標未達(0<=100%)</span>
        </div>
      </div>
      <div class="ms-3">
        <div class="d-flex align-items-center">
          <span class="square" :style="{'background-color': this.barColor(0)}"></span>
          <span class="ms-1">記録なし(0%)</span>
        </div>
      </div>
      
    </div>
    <apexchart type="bar" :height="isExpand ? 660 : 400" :options="chartOptions" :series="series" ref="chart" />
  </div>
</template>

<script>
import api from "@/api";
import moment from "moment";
import {keyBy} from "lodash";

export default {
  data() {
    return {
      start: '',
      end: '',
      standardMet: 3.3,
      percents: this.defaultPercents(),
      series: this.defaultSeries(),
      chartOptions: {
        colors: [this.barColors],
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: {show: true},
          zoom: {enabled: false},
          parentHeightOffset: 0,
          offsetY: 10,
        },
        annotations: {
          yaxis: [
            {
              y: 3.3,
              borderColor: '#212529bf',
              borderWidth: 1.5,
              strokeDashArray: 6,
            },
          ],
        },
        responsive: [{
          options: {
            legend: {
              position: 'bottom',
            }
          }
        }],
        dataLabels: {
          formatter: (val, opts) => [val, `(${this.percents[opts.seriesIndex][opts.dataPointIndex]}%)`],
          style: {
            colors: ['#495057'],
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
            columnWidth: '70%',
            dataLabels: {
              position: 'center',
              total: {
                enabled: false,
                formatter: (value) => Number(value).toFixed(2),
              }
            },
          },
        },
        xaxis: {
          categories: [],
          labels: {
            maxHeight: 60,
          },
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: (val, opts) => `${val} (${this.percents[opts.seriesIndex][opts.dataPointIndex]}%)`,
          }
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left'
        },
        fill: {
          opacity: 1
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
          active: {
            filter: {
              type: 'none',
            }
          },
        },
      },
      chartFormat:'week',
      firstDayOfMonth:'',
      lastDayOfMonth:'',
      dataLabelsEnabled: true,
      rotate: false,
    }
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    time_out_facility: {
      type: String,
      required: false
    },
    theme: {
      type: String,
      required: false
    },
    isExpand: {
      type: Boolean,
    }
  },
  computed: {
    displayRange: function () {
      return `${moment(this.start).format('YYYY/MM/DD')}~${moment(this.end).format('DD')}`;
    },
    displayRangeMonth: function () {
      return `${moment(this.firstDayOfMonth).format('YYYY/MM/DD')}~${moment(this.lastDayOfMonth).format('DD')}`;
    }
  },
  watch: {
    isExpand: {
      handler() {
        if(this.chartFormat === 'week'){
          this.updateChart(this.start, this.end);
        } else if (this.chartFormat === 'month'){
          this.updateChart(this.firstDayOfMonth, this.lastDayOfMonth);
        }
      }
    }
  },
  async mounted() {
    this.renderChart();
  },
  methods: {
    barColor(percent) {
      if (percent >= 100) {
        return this.theme == 'plus' ? "#65ACE2" : '#8FC31F';
      } else if (!percent) {
        return '#EEE';
      } else {
        return '#FCC062';
      }
    },
    barColors(arg) {
      const percent = this.percents[arg.seriesIndex][arg.dataPointIndex];

      return this.barColor(percent);
    },

    renderChartConvert(){
      this.getFirstAndLastDayOfMonth();
      this.getMondayAndSunday();
      this.renderChart();
    },

    defaultSeries() {
      return [
        {
          name: '活動量',
          data: [],
        }
      ];
    },
    defaultPercents() {
      return [[], [], []];
    },
    listDates(start, end) {
      const startDate = moment(start);
      const endDate = moment(end);
      const dateArray = [];

      while (startDate.isSameOrBefore(endDate)) {
        dateArray.push(startDate.format('YYYY-MM-DD'));
        startDate.add(1, 'days');
      }

      return dateArray;
    },
    getMondayAndSunday(date) {
      const inputDate = moment(date);
      const monday = inputDate.clone().startOf('isoWeek');
      const sunday = inputDate.clone().endOf('isoWeek');
      return [monday.format('YYYY-MM-DD'), sunday.format('YYYY-MM-DD')];
    },
    async updateChart(start, end) {
      const time_out = moment(this.time_out_facility).format('YYYY-MM-DD');
      const res = await api.statsMetRange(this.user.id, start, end > this.time_out_facility ? time_out : end);
      if (res.status === 200) {
        const dates = this.listDates(start, end);
        const series = this.defaultSeries();
        const percents = this.defaultPercents();
        const items = keyBy(res.data.items, 'submit_at');
        let datesFormatted = [];
        const dayMapping = {
          'Sun': '日',
          'Mon': '月',
          'Tue': '火',
          'Wed': '水',
          'Thu': '木',
          'Fri': '金',
          'Sat': '土',
        };
        let maxVal = 3.3;
        for (let date of dates) {
          const totalStat = items[date]?.total_stat || 0;
          series[0].data.push(this.roundValue(totalStat));
          percents[0].push(this.roundPercent(items[date]?.percent_stat));

          if (totalStat > maxVal) {
            maxVal = totalStat;
          }

          datesFormatted.push(moment(date).format(`MM/DD(${dayMapping[moment(date).format('ddd')]})`));
        }

        this.percents = percents;
        this.$refs.chart.updateOptions({dataLabels: {enabled:this.dataLabelsEnabled}});
        this.$refs.chart.updateSeries(series);
        this.$refs.chart.updateOptions({xaxis: { categories: datesFormatted, labels: {rotateAlways: this.rotate,} }, yaxis: { min: 0, max: maxVal}, chart: {height: this.isExpand ? 660 : 400}});
      }
    },
    roundValue(value, fractionDigits = 2) {
      if (isNaN(value)) {
        return 0;
      }

      const power = 10 ** fractionDigits;

      return Math.floor(Number(value)  * power) / power;
    },
    roundPercent(rawPercent) {
      return this.roundValue(rawPercent, 0);
    },
    renderChart(date = new Date()) {
      const [start, end] = this.getMondayAndSunday(date);
      this.start = start;
      this.end = end;
      if(this.chartFormat === 'week'){
        this.updateChart(start, end);
      } else if (this.chartFormat === 'month'){
        this.updateChart(this.firstDayOfMonth, this.lastDayOfMonth);
      } else {
        this.updateChart(start, end);
      }
    },
    getFirstAndLastDayOfMonth() {
      const currentDate = moment();
      this.firstDayOfMonth = moment(currentDate).startOf('month').format('YYYY-MM-DD');;
      this.lastDayOfMonth = moment(currentDate).endOf('month').format('YYYY-MM-DD');
    },

    nextMonth() {
      if (!this.isFutureMonth()) {
        const currentFirstDay = moment(this.firstDayOfMonth);
        this.firstDayOfMonth = currentFirstDay.add(1, 'months').startOf('month').format('YYYY-MM-DD');
        this.lastDayOfMonth = currentFirstDay.endOf('month').format('YYYY-MM-DD');
        this.renderChart()
      }
    },

    prevMonth() {
      const currentFirstDay = moment(this.firstDayOfMonth);
      this.firstDayOfMonth = currentFirstDay.subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
      this.lastDayOfMonth = currentFirstDay.endOf('month').format('YYYY-MM-DD');
      this.renderChart()
    },
    nextWeek() {
      if (!this.isFuture()) {
        const nextMonday = moment(this.start).clone().add(7, 'days').toDate();
        this.renderChart(nextMonday);
      }
    },
    prevWeek() {
      const prevMonday = moment(this.start).clone().subtract(7, 'days').toDate();
      this.renderChart(prevMonday);
    },
    isFuture() {
      return moment(this.end) >= moment();
    },
    isFutureMonth() {
      const today = moment();
      return today.isSameOrBefore(moment(this.lastDayOfMonth), 'month');
    },
  }
}
</script>

<style scoped>
.disabled.input-group-append {
  opacity: 0.5;
  cursor: default;
}
.square {
  display: inline-block;
  width: 15px;
  height: 15px;
}
.button-month-week{
  margin-left: 6px;
  height: 24px;
  width: 90px;
  margin-top: 5px;
  border-radius: 10px;
  border: 0px
}
</style>
